module.exports = __webpack_public_path__ + "img/finishUpload.172b2b72.svg";